export const NewAssistantPath = `assistants`; //TODO: WILL REMOVE THIS WHEN I MOVE THE ROUTES OUT OF ASSISTANTS
export const CommentsPath = `comments`;
export const CommentPath = `${CommentsPath}/:commentId`;
export const EventsPath = `events`;
export const UsersPath = 'user';
export const ScopesPath = 'dealgpt/scope';
export const SummaryChatPath = 'dealgpt/summary-chat';
export const DiscoveryScopesPath = `${ScopesPath}/discovery`;
export const AnalysisScopesPath = `${ScopesPath}/analysis`;
export const CollectionsPath = 'dealgpt/collections';
export const CollectionCreatorsPath = 'dealgpt/collections/creators';
export const CollectionsUploadPath = 'dealgpt/collections/upload';
export const CollectionTagsPath = 'dealgpt/collections/tags';
export const CollectionPath = 'dealgpt/collections/:collectionId';
export const CategoriesPath = 'dealgpt/categories';
export const CategoryPath = 'dealgpt/categories/:categoryId';
export const ReorderCategoriesPath = 'dealgpt/categories/reorder';
export const QuestionsPath = 'dealgpt/questions';
export const QuestionPath = 'dealgpt/questions/:questionId';
export const ReorderQuestionsPath = 'dealgpt/questions/reorder';
export const ProjectsPath = 'dealgpt/project';
export const AdminProjectsPath = 'dealgpt/admin/project';
export const ProjectPath = 'dealgpt/project/:projectId';
export const TeamsPath = `dealgpt/teams`;
export const TeamsFolderExistsPath = `${TeamsPath}/folder-exists`;
export const ProjectDefaultKPIsPath = `${ProjectPath}/default-kpis`;
export const CreateProjectRunPath = `${ProjectPath}/run`;
export const LatestProjectRunPath = `${ProjectPath}/run/latest`;
export const ProjectRunPath = `${ProjectPath}/run/:runId`;
export const StartProjectRunPath = `${ProjectRunPath}/start`;
export const ProjectRunProgressPath = `${ProjectRunPath}/progress`;
export const ProjectRunScopesPath = `${ProjectRunPath}/scopes`;
export const ProjectRunStatusesPath = `${ProjectRunPath}/status`;
export const ProjectConfigPath = `${ProjectPath}/config`;
export const ProjectConfigStatusPath = `${ProjectPath}/config/status`;
export const ProjectSalesforceInfo = `${ProjectPath}/config/salesforce`;
export const ProjectDataProcessPath = `${ProjectPath}/start-extraction`;
export const ProjectKpisRunPath = `${ProjectRunPath}/kpis`;
export const ProjectSemaRunPath = `${ProjectPath}/latest-sema-run`;
export const InvestmentThesisPath = `${ProjectConfigPath}/investment_thesis`;
export const CreateKpiQuestionPath = `${ProjectConfigPath}/kpi_question`;
export const DeleteKpiQuestionPath = `${ProjectConfigPath}/kpi_question/:questionId`;
export const KpiQuestionVersionsPath = `${ProjectConfigPath}/kpi_question/:questionId/versions`;
export const KeyQuestionPath = `${ProjectConfigPath}/key_question`;
export const DeleteKeyQuestionPath = `${ProjectConfigPath}/key_question/:questionId`;
export const KeyQuestionRelevantDocsPath = `${ProjectConfigPath}/key_question/:questionId/relevant_documents`;
export const GenerateDiscoveryReportPath = `${ProjectPath}/generate-report`;
export const AnalysisPath = `dealgpt/analysis`;
export const GenerateAnalysisReportPath = `${AnalysisPath}/report/:projectId/:scope/:runId`;
export const RecalculateBenchmarksPath = `${AnalysisPath}/benchmarks/:projectId/:runId/recalculate`;
export const ProjectQuestionPath = 'dealgpt/projectQuestion';
export const ProjectQuestionRescanPath = `${ProjectQuestionPath}/rescan`;
export const ProjectQuestionRunInclusionPath = `${ProjectQuestionPath}/:questionId/run-inclusion`;
export const fetchQuestionAllVersionsPath = `${ProjectQuestionPath}/:questionId/versions`;
export const fetchCategoryQuestionsPath = `${ProjectQuestionPath}/:projectId/scope/:scopeName/category/:categoryName/:runId/questions`;
export const SOWExtractionPath = `${ProjectConfigPath}/document-extraction/sow`;
export const PromptPath = `prompts/prompt/:promptId`;
export const GenerateRecommendationPromptPath = `prompts/recommendation`;
export const PromptLabelDefinitionsPath = `prompts/label-definitions`;
export const PromptLabelsPath = `prompts/labels`;
export const PromptTypesPath = `prompt-types`;
export const PromptTypePath = `${PromptTypesPath}/:promptTypeId`;
export const PromptVersionsPath = `${PromptPath}/versions`;
export const PromptSuggestionsPath = `prompts/suggestions`;
export const ReportsPath = `dealgpt/reports`;
export const ConflictReportValidationPath = `${ReportsPath}/conflict-report/:projectId/validation`;
export const ConflictReportPath = `${ReportsPath}/conflict-report/:projectId`;
export const UserRequestsPath = `user-requests`;
export const NotificationsPath = `notifications`;
export const NotificationPath = `notifications/:notificationId/dismiss`;
export const TemporaryChatPath = 'temporary-chat';
export const NewChatPath = 'new-chat';
export const FolderPath = 'folder';
export const FoldersPath = 'folders';
export const DataRequestList = `${ProjectPath}/data-request-list`;
export const DataRequestListAll = `${DataRequestList}/all`;
export const DataRequestListBulk = `${DataRequestList}/bulk`;
export const DataRequestListReIndex = `${DataRequestList}/re-index/:indexType`;
export const DataRequestItem = `${DataRequestList}/:itemId`;
export const DataRequestItemQuestions = `${DataRequestItem}/applicable-questions`;
export const SummaryChatAssistantPath = `${SummaryChatPath}/:projectId/assistant`;
export const SummaryChatFilesPath = `${SummaryChatPath}/:projectId/files`;
export const SummaryChatFilesAssistantPath = `${SummaryChatPath}/:vectorStoreId/assistant`;
export const ConversationsPath = `conversations`;
export const IndexPath = `indexes`;
export const GraphRagVisualizationPath = 'graph-rag/:graphIndexId';
